
import { Component } from 'vue-facing-decorator'
import { ListViewVue } from '@/common/BaseVue'
import {
  getCouponTypeName as couponTypeName,
  getCouponContent as couponContent,
  getCouponStock as couponStock,
} from '@/common/coupon'

@Component({})
export default class extends ListViewVue {
  /** 类组件只有类成员能在模板里访问，模块级 import 要挂到实例上 */
  getCouponTypeName = couponTypeName;
  getCouponContent = couponContent;
  getCouponStock = couponStock;

  selectedCoupon: any = null;

  get checkedId() {
    return this.selectedCoupon ? this.selectedCoupon.id : null;
  }

  toggle(row) {
    if (row.status != 1) return;
    this.selectedCoupon = row;
  }

  /** 选中项是整个券行，调用方只用 id（配发货方式时存 couponId） */
  choose() {
    if (!this.selectedCoupon) {
      return this.$error("请选择优惠券");
    }
    this.$emit("resolve", this.selectedCoupon);
  }

  cancelEvent() {
    this.$emit("reject", { msg: "取消" });
  }

  /** 列表接口只支持分页、没有名称筛选，所以这里不做搜索框 */
  getList() {
    return this.$post("/manager/coupon/list", this.mesureData);
  }
}
